/* DSL Live inventory polling — refetch /products/{handle}.js elke 60s op product page */
(function(){
  if (location.pathname.indexOf("/products/") !== 0) {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var handle = m[1];
  } else {
    var handle = location.pathname.split("/")[2];
  }
  if (!handle) return;
  function refresh(){
    fetch("/products/" + handle + ".js").then(function(r){return r.json();}).then(function(p){
      document.querySelectorAll("[data-variant-id]").forEach(function(el){
        var vid = parseInt(el.dataset.variantId, 10);
        var v = p.variants.find(function(x){ return x.id === vid; });
        if (v) {
          el.dataset.available = v.available ? "1" : "0";
          if (v.inventory_quantity !== undefined) el.dataset.qty = v.inventory_quantity;
        }
      });
    }).catch(function(){});
  }
  if (document.visibilityState === "visible") refresh();
  setInterval(function(){ if (document.visibilityState === "visible") refresh(); }, 60000);
})();